/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * Value (out of 100) of the requested quality for placeholder images.
 */
export const PLACEHOLDER_QUALITY = '20';
